'use client'

import { useEffect, useState } from 'react'
import { MaterialIcon } from '@/components/ui/MaterialIcon'

// Scroll-to-top button — appears after the user scrolls down, smooth-scrolls
// back to the top. Navigational UX signal recommended for AdSense review.
export function ScrollToTop() {
    const [visible, setVisible] = useState(false)

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > 400)
        window.addEventListener('scroll', onScroll, { passive: true })
        onScroll()
        return () => window.removeEventListener('scroll', onScroll)
    }, [])

    if (!visible) return null

    return (
        <button
            type="button"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            aria-label="Back to top"
            title="Back to top"
            className="fixed bottom-6 right-6 z-50 flex h-12 w-12 items-center justify-center rounded-full bg-primary text-white shadow-lg shadow-primary/30 transition-all hover:scale-110 active:scale-95"
        >
            <MaterialIcon name="arrow_upward" />
        </button>
    )
}
